import React from 'react'
import { useTranslation } from 'react-i18next'

import Avatar from '../Avatar'
import PageName from '../PageName'
import AdPrimaryText from '../AdPrimaryText'

import { FB_PAGE_CHOICE, FB_SPONSOR_PAGE_ID } from '../../../../../forms/Facebook/AdForms/fields'

import useStyles from './styles'

const FacebookAdPreviewHeader = ({ elementInProgress, formikValues }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.adCardHeader}>
      <div className={classes.headerTop}>
        <div className={classes.avatar}>
          <Avatar pageId={formikValues[FB_PAGE_CHOICE]} />
        </div>
        <div className={classes.info}>
          <div className={classes.name}>
            <PageName
              elementInProgress={elementInProgress}
              pageId={formikValues[FB_PAGE_CHOICE]}
              sponsorPageId={formikValues[FB_SPONSOR_PAGE_ID]}
            />
          </div>
          <div className={classes.description}>{t('Sponsored')}</div>
        </div>
      </div>
      <div className={classes.adText}>
        <AdPrimaryText elementInProgress={elementInProgress} formikValues={formikValues} />
      </div>
    </div>
  )
}

export default FacebookAdPreviewHeader
